// extracted by mini-css-extract-plugin
export var wrapper = "QuestionsSection-module--wrapper--pmgLW";